import { DateTime } from 'luxon';
import { GetMultipleBanksProps, MultipleBankAndAccessCodes } from './types';
import getCatalogLink from './getCatalogLink';

export const getMultipleBanks = ({
  layout,
  currentIdentity,
  hasMultipleBank,
  t,
}: GetMultipleBanksProps) => {
  type BankWithExtras = MultipleBankAndAccessCodes & {
    accessCodes?: MultipleBankAndAccessCodes[];
    defaultBank?: boolean;
  };

  const multipleBanks = sort(
    layout?.bankBalance?.map((bank): BankWithExtras => {
      const accessCodes = bank?.accessCodeDetails?.map((access) => {
        const dateTime = DateTime.fromFormat(
          access.expiresAt,
          'yyyy-MM-dd hh:mm:ss.S',
        );
        return {
          category: t('prism-header:access-codes', 'Access Codes'),
          primary: access.accessCode,
          secondary: t(
            'prism-header:expiring-access-codes',
            'Expires {accessCodeDate}',
            {
              accessCodeDate: dateTime.toLocaleString(DateTime.DATE_SHORT),
            },
          ),
          url: getCatalogLink({
            referrerUrl: window.location.href,
            bank: bank,
            currentIdentity,
          }),
        };
      });
      return {
        category: t('prism-header:bank-accounts', 'Bank Accounts'),
        primary: bank.bankName,
        secondary: bank?.points?.toString(),
        url: getCatalogLink({
          referrerUrl: window.location.href,
          bank: bank,
          currentIdentity,
        }),
        accessCodes,
        defaultBank: bank.defaultBank,
      };
    }) || [],
    'defaultBank',
  );
  const banksWithAccessCodes = multipleBanks?.filter(
    (o) => o.accessCodes && o.accessCodes.length > 0,
  );

  const accessCodes = banksWithAccessCodes?.flatMap((bank) => {
    return bank.accessCodes;
  }) as MultipleBankAndAccessCodes[];

  const vettedMultipleBanks = multipleBanks?.map((bank) => {
    return {
      category: bank.category,
      primary: bank.primary,
      secondary: bank.secondary,
      url: bank.url,
    };
  }) as MultipleBankAndAccessCodes[];

  return hasMultipleBank ? { vettedMultipleBanks, accessCodes } : {};
};

const sort = <Type>(arr: Type[], key: keyof Type) =>
  arr?.sort((a, b) => {
    if (a[key]) return -1;
    if (b[key]) return 1;
    return 0;
  });
// sort multiple banks by default bank

export const sortAccessCodes = (accessCodes?: MultipleBankAndAccessCodes[]) =>
  accessCodes?.sort((a, b) => {
    const dateA = a.secondary?.split(' ')[1];
    const dateB = b.secondary?.split(' ')[1];
    return (
      new Date(dateA).getTime() - new Date(dateB).getTime() ||
      a.secondary?.localeCompare(b.secondary)
    );
  });
